/* eslint-disable max-lines */
import type { EcsProjectTeamName } from '../types';

export type Experiment =
  | 'AdhocAudienceAnnouncement'
  | 'AdhocAudienceAnnouncementV2'
  | 'AdhocUnifiedAudiencePicker'
  | 'AdhocAudiencePickerCustomGroups'
  | 'AdhocAudiencePickerCustomGroupsV2'
  | 'AdminRoleManagement'
  | 'AdminRoleManagementPostGa'
  | 'AdvancedModerationTableWithSort'
  | 'AlwaysEnableJoinInEventButton'
  | 'AnalyticsInCCDashboard'
  | 'AnswerCommunitySearchUX'
  | 'AnswersForagerGroups'
  | 'AnswersInVivaGA'
  | 'AnswersToggle'
  | 'AnswersToggleUpdate'
  | 'AnswersUpdates'
  | 'ArticleAuthorHeader'
  | 'ArticleDesignerEditor'
  | 'ArticleAutoGeneratedHeaderImage'
  | 'ArticleFullViewInModal'
  | 'ArticleInMTOCommunity'
  | 'ArticleMultiColumn'
  | 'ArticleTableofContents'
  | 'AutoCloseConversationGlobalToggle'
  | 'AutoSuggestionCampaignHashtag'
  | 'BackendCellOverride'
  | 'BackendGraphqlApiVnextEndpoint'
  | 'BackendGraphqlApiV5Endpoint'
  | 'BackendLiveEventFeedCaching'
  | 'BackendLiveEventFeedCachingByTenant'
  | 'BackendOcularCosmos'
  | 'BackendStreamieCosmos'
  | 'BellPageSize'
  | 'BespokeCommunityCreateEdit'
  | 'BookmarkThread'
  | 'CKArticlePublisher'
  | 'CKArticlePublisherImageCropping'
  | 'CKArticlePublisherImageResizing'
  | 'CKArticlePublisherCaptions'
  | 'CKRelayReplyPublisher'
  | 'CampaignsCoOrganizers'
  | 'CampaignsExecutiveSponsorship'
  | 'CampaignsHub'
  | 'CampaignHoverCard'
  | 'CampaignFollowerDetails'
  | 'CommunityAgent'
  | 'CommunityAgentAdmin'
  | 'CommunityAgentAtMention'
  | 'CommunityAgentDogfood'
  | 'CommunityAgentPreview'
  | 'CommunityAgentPrivatePreview'
  | 'CommunityAgentRecommendedReplies'
  | 'CommunityAgentSPGrounding'
  | 'CommunityAIGeneratedBanner'
  | 'CommunityAIBannerUpdate'
  | 'CommunityBadgeAdmin'
  | 'CommunityCoachTips'
  | 'CommunityDynamicGroupMembership'
  | 'CommunityFeatureConversation'
  | 'CommunityInsightsV2ThreadMetrics'
  | 'CommunityLeads'
  | 'CommunityLeadsAndAutoPin'
  | 'CommunityRelayBanner'
  | 'CommunityRelayDataLoader'
  | 'CommunitySettingsPage'
  | 'CommunitySetupTeachingBubbles'
  | 'CommunitySidebarReorderStatic'
  | 'CompactHeaderGeneral'
  | 'CompactHeaderStoryline'
  | 'CompanyLogoInLCHeader'
  | 'CopilotAdoptionCommunityAdminFRE'
  | 'CopilotFloatieButtonOverhaul'
  | 'CampaignTargeting'
  | 'CampaignTargetingV2'
  | 'CondensedQuestionFeed'
  | 'CopilotCommunityConversion'
  | 'DelegateRequest'
  | 'DelegateRequestBell'
  | 'DisableHomePremiumEventsCard'
  | 'DisablePollPostType'
  | 'DiscoverCommunitiesV2'
  | 'DiscoverOfficialCommunities'
  | 'DivisionalBespokeCommunity'
  | 'DogfoodPerfHUD'
  | 'DomainMigration'
  | 'DraftAndScheduledPostSeeded'
  | 'DraftPublisherWithCopilot'
  | 'ECDNSupportForEvents'
  | 'EngageCustomBrandingTheming'
  | 'EnableDeleteOptions'
  | 'EngageStorylinesCoverPhotoDragAndCrop'
  | 'EnhancedDigestDiscoveryDesign'
  | 'EventPreviews'
  | 'ExpertNominationToggle'
  | 'ExpertSelfNominationInTeams'
  | 'ExportEventQuestions'
  | 'ExtendedUnSeenCountEnabled'
  | 'FavoritesDragDropReorder'
  | 'FeedLoadNumThreads'
  | 'FeedLoadMoreNumThreads'
  | 'FilesCookielessAuth'
  | 'FlagThreadForLeader'
  | 'FollowButtonHomeFeedThreadWithGreyColor'
  | 'GroupFeedFilterAndSortByExp'
  | 'GroupFeedSortRecentPostsWeb'
  | 'GroupFeedSortRecentPostsTBE'
  | 'GroupHoverCardV2'
  | 'HideFilesRelatedResources'
  | 'HideUserGlobalToggle'
  | 'HomeFeedGroupJoinButtonForRecommendations'
  | 'CommunityFilesTabVisibilitySetting'
  | 'HomeFollowingFeed'
  | 'HydrantOptionsRefactoring'
  | 'IFrameSandboxForSharePointVideoCard'
  | 'ImageCompressionWeb'
  | 'InboxRelay'
  | 'InFeedUserSuggestions'
  | 'InformationBarriersPhase0'
  | 'InsightsFluent9Charts'
  | 'IntelligentImporterBulkDelete'
  | 'IntelligentImporterDeleteOnPublish'
  | 'KeywordOverrideAgentClientForward'
  | 'KnowledgeBespokeCommunity'
  | 'LeaderAudienceFeed'
  | 'LeaderAudiencePickerCustomGroups'
  | 'LeaderDashboard'
  | 'LeadersViewDelegation'
  | 'LeaderGroupsAddAsync'
  | 'LeaderManagementActivityLog'
  | 'LeadersAudienceM365Support'
  | 'LeadersCascadeCTA'
  | 'LeadershipCornerPinnedPosts'
  | 'LightboxFollowUsers'
  | 'LimitConversationMoveSettingsAndFilter'
  | 'LinkPreviewForSuggestedContent'
  | 'LiveEventsScaleLoadPerf'
  | 'LoadThreadDataWhileRouting'
  | 'LoadFeedDataWhileRouting'
  | 'LogProtobufEvents'
  | 'LoopFilePreview'
  | 'M365CopilotAdoption'
  | 'M365CopilotAdoptionSuggestedMembers'
  | 'MicrosoftDesignerApp'
  | 'MinimalWFPayloadOnReplyPosting'
  | 'MIPEnabledForEveryone'
  | 'MessagesReactionsAPI'
  | 'MessagesReactionsAPIV2'
  | 'MessagesReactionsAPIWrite'
  | 'ModerationAgent'
  | 'ModerationAgentBlockPost'
  | 'ModerationAgentBlockPostPreRollout'
  | 'ModerationDetectedConversations'
  | 'ModerationThemeDetectedEmailNotification'
  | 'MoveConversationGlobalToggle'
  | 'MTOBlendedInbox'
  | 'MTOCampaigns'
  | 'MTOPolicyEngageAdminPortalPage'
  | 'MTOSpokeMemberAdmin'
  | 'EnablePermalinkDeeplink'
  | `MultiTenantOrganization`
  | 'MultiLanguagePublisher'
  | 'MutedAutoPlay'
  | 'MutedAutoPlayYouTubeVimeo'
  | 'MyGroupsAdminOfFilter'
  | 'MyTeamAudience'
  | 'NetworkQuestionsInConversations'
  | 'NotificationsAnnouncementCopyUpdate'
  | 'NotificationTracker'
  | 'NoWFMessageBodyInGroupMessageCreationResponse'
  | 'OdspFilePickerType'
  | 'OfficeTopics'
  | 'OnboardingForCommunitiesInTeams'
  | 'OneEventsAmaInsights'
  | 'OnePlayer'
  | 'OnePlayerV2'
  | 'OnePlayerNative'
  | 'OpenPublisherWithModal'
  | 'OpenPublisherWithCopilotModal'
  | 'OrgDataGovernance'
  | 'OrgDataQuality'
  | 'OptimizedReactionsFetching'
  | 'PeopleSuggestion3SV3'
  | 'PinnedFiles'
  | 'PostOnBehalfOfCommunityHomePublisher'
  | 'PrefilledDefaultAudience'
  | 'PremiumEventUpdates'
  | 'PrivateRepliesAMA'
  | 'PublisherQuestionPrompt'
  | 'PublisherSuggestedTopics'
  | 'PublisherV2'
  | 'PWALegacyBrokenExperience'
  | 'PWANotificationsDisabled'
  | 'QuestionsQueue'
  | 'LeadersSettingCard'
  | 'QuestionTitlesV3'
  | 'QuickNavManageMyThings'
  | 'ReactionSimplification'
  | 'ReadOnlyMode'
  | 'RealtimeCometdDebugLogs'
  | 'RealtimeDebugEventReporting'
  | 'RemoveTopicsSDKDependencyForVivaTopicsInFeeds'
  | 'ReplaceUrlWithTitleInPublisher'
  | 'ReportConversationMigration'
  | 'RestrictPostingAnyGroupRollout'
  | 'RoleBasedFRE'
  | 'SearchDiscoverabilityFRE'
  | 'SearchAutocompletePromptSuggestions'
  | 'SearchAutocompleteTrendingThemeAndHistory'
  | 'SeededLeader'
  | 'ServerSharePointWebLinks'
  | 'SharePointTempAuthUrlDeprecation'
  | 'SharePointTempAuthUrlDeprecationByTenant'
  | 'SharePointVideoLinkPreviews'
  | 'ShowUserCoverImage'
  | 'SimplifyExpertVerification'
  | 'SimplifyExpertVerificationInTeams'
  | 'SmallFileUpload'
  | 'SplitDataAndPresentationComponents'
  | 'Stories'
  | 'StoriesV2Cards'
  | 'StorylineAIGeneratedCoverPhotosEngageWeb'
  | 'StorylineAIGeneratedCoverPhotosTBE'
  | 'StorylineAnnouncementNotificationUrgency'
  | 'StorylineAnnouncementTeachingBubbleAndDisableInfobar'
  | 'StorylineAsDefaultOnHomePublisher'
  | 'StorylineDefaultHomeFeedPublisherLongv2'
  | 'StorylineDirectAndDigestRebrand'
  | 'StorylineEmptyFeedEducationModule'
  | 'StorylineEmptyFeedTeamsExperience'
  | 'StorylineFeaturedPostsSeeded'
  | 'StorylineFeedFiltersTBE'
  | 'StorylineMediaPost'
  | 'StorylineMediaPostGA'
  | 'StorylinePOBOSeeded'
  | 'StorylinePublisherCoachingTips'
  | 'StorylinePublisherTipsLongV3'
  | 'StorylinePublisherTipsShortV3'
  | 'StorylineEventsSwimlaneView'
  | 'StorylineThreadCoachingTips'
  | 'StorylineThreadTipsLongV3'
  | 'StorylineThreadTipsShortV3'
  | 'StreamLiveEventDeprecationExtension'
  | 'SuggestedArticleFormatForSeeded'
  | 'SuggestedContentGuidedAdminExperience'
  | 'SystemInitiatedEngageFeedback'
  | 'TBEConnectionsSuggestion'
  | 'TBEMultiLanguagePublisher'
  | 'TBENewFollowersPage'
  | 'TeamsBackButton'
  | 'TeamsClientDataLayer'
  | 'TeamsBrandedExperiencesBackgroundLoadR4Rollout'
  | 'TeamsBrandedExperiencesCachedFeedLoad'
  | 'TeamsBrandedExperiencesTimeoutBasedCachedFeedLoad'
  | 'TeamsBrandedExperiencesCommunityCDLSync'
  | 'TeamsBrandedExperiencesCommunityFeatures'
  | 'TeamsBrandedExperiencesCommunityFeedRelay'
  | 'TeamsBrandedExperiencesIdbCache'
  | 'TeamsBrandedExperiencesEvents'
  | 'TeamsBrandedExperiencesLastReadBar'
  | 'TeamsBrandedExperiencesOpenStorylineTab'
  | 'TeamsBrandedExperiencesPinnedCollapsibleRightRail'
  | 'TeamsBrandedExperiencesServiceWorker'
  | 'TeamsBrandedExperiencesUseEngageCoachmarks'
  | 'TeamsBrandedExperiencesFREShowLearnMore'
  | 'TeamsBrandedExperiencesFilesTab'
  | 'TeamsBrandedRightRailRedesign'
  | 'TeamsDigest'
  | 'TeamsFocusCommandsInEngageApp'
  | 'TeamsMeetingAccess'
  | 'TeamsMeetingDisableReactionsOption'
  | 'TeamsMeetingMaskIdentitiesBanner'
  | 'TeamsQnAFeedReset'
  | 'TeamsQnAInOneEventsLandingPage'
  | 'TeamsQnaLocalDevelopment'
  | 'TeamsQnANestedAuthAppSupport'
  | 'TeamsQnAPostAsModeratorNotifications'
  | 'TeamsQnAPostAsModeratorSenderDetails'
  | 'TeamsQnARoutingHeadersForSplitRegion'
  | 'TeamsQnAUXUpdates'
  | 'TeamsTownhallEventInVivaEngage'
  | 'TeamsUserInitiatedEngageFeedback'
  | 'ThreadCopyLinkV2'
  | 'ToggleEventModeration'
  | 'TownhallEmbedRingOverride'
  | 'TownhallMeetingOptions'
  | 'UCBSquareDesign'
  | 'UseBatchedFiles'
  | 'UseEditV1Api'
  | 'UserInitiatedEngageFeedback'
  | 'UserSettingsNotificationsLoader'
  | 'VivaEngageAdminBanner'
  | 'EventAnonymousPosting'
  | 'PremiumEventExperience'
  | 'PremiumEventCalendarOnBehalfOfExperience'
  | 'PrivatePremiumEventCreation'
  | 'ViewerTimeZoneCapture'
  | 'VivaEngageCampaignPlugin'
  | 'VivaEngageCollapsiblePanelRecommendations'
  | 'VivaEngageCopilotBE'
  | 'VivaEngageCopilotDebug'
  | 'VivaEngageCopilotWAGpt4'
  | 'VivaEngageCopilotWAPersonalized'
  | 'VivaEngageCoverImage'
  | 'VivaEngageDeepLinkFromOWA'
  | 'VivaEngageAugLoopEnvironment'
  | 'VivaEngageGlobalCopilot'
  | 'VivaEngageGlobalCopilotTenant'
  | 'VivaEngageLC'
  | 'VivaEngagePremium'
  | 'VivaEngageTeamsLiveEventMobile'
  | 'VivaLeadershipChronoFeed'
  | 'VivaLeadershipCuratedFeed'
  | 'UnseenThreadStarterInInbox'
  | 'ArticleSuggestionBar'

  // Existing experiments that incorrectly have 'Enabled' as part of their name.
  // Do not do this - 'enabled' should be |of an experiment not part of the name.
  // The name should instead focus on describing the feature/functionality affected.
  // Since these are |and in use we |t rename them so just have
  // to let them run their course.
  | 'ModulatorGroupSuggestionsEnabled'

  // Experiments used for testing the experiment infrastructure - grouping
  // these separately from the regular feature experiments above. Regular
  // experiments should not have the name 'experiment' in them.
  | 'ClientForwardExperimentForTesting1'
  | 'ClientForwardExperimentForTesting2'
  | 'CrossPlatformExperimentForTesting1'
  | 'CrossPlatformExperimentForTesting2'
  | 'ExperimentForTesting1'
  | 'ExperimentForTesting2';

export type ExperimentTreatmentValue = string | boolean | number;

export interface ExperimentConfig {
  readonly id: string | undefined;
  readonly projectTeam: EcsProjectTeamName;
  readonly treatments: ExperimentTreatmentValue[];
  readonly defaultTreatment: ExperimentTreatmentValue;
}

export const experimentConfigs: ExperimentConfigs = {
  AdhocAudienceAnnouncement: {
    id: 'e00edc3f-f7d1-483f-affe-81309a599485',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdhocAudienceAnnouncementV2: {
    id: '87bc77db-24b8-4e6e-bf74-86a722edbec9',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdhocUnifiedAudiencePicker: {
    id: 'be379326-6597-4b5f-a7ae-96db939e3fe1',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdhocAudiencePickerCustomGroups: {
    id: 'd1d516a8-11d8-4fa7-ba2d-242be3da2f9c',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdhocAudiencePickerCustomGroupsV2: {
    id: 'f70c4556-edcf-45ca-a31a-83153f9970e0',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdminRoleManagement: {
    id: 'df4c49e2-1204-4a2e-8c25-ecf42b53cdca',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdminRoleManagementPostGa: {
    id: 'a6fc3318-67c4-491f-b792-9e4afe99ecce',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdvancedModerationTableWithSort: {
    id: 'aab97be9-046f-4666-80be-357a2bf70e4b',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AlwaysEnableJoinInEventButton: {
    id: '1d16f6bd-f6e6-40e0-8ad9-efa779220daa',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnalyticsInCCDashboard: {
    id: '7c3370f5-ca44-4678-867c-c521007a8fdc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswerCommunitySearchUX: {
    id: '4435a113-a41e-4a86-9517-5877cc008ab7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersForagerGroups: {
    id: '18278c4f-67a3-4760-b90c-ba4e80253582',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersInVivaGA: {
    id: '380a21a6-bc1e-4619-aa37-f11e947f9844',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersToggle: {
    id: '4235a1a4-f403-4426-b53d-889880fb51a4',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersToggleUpdate: {
    id: 'bf9daeec-d0a3-483a-9714-d7402758f1bd',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersUpdates: {
    id: '4f9555aa-a589-487f-8b8b-a8a43fa3b9ab',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleAutoGeneratedHeaderImage: {
    id: '93665fdb-9c42-4d42-83c7-369072341b1d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleAuthorHeader: {
    id: 'dc1e1501-316a-4293-80d9-07271aab700a',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleDesignerEditor: {
    id: 'd5b5ea32-9271-4afd-8326-f5abc7dc0180',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleFullViewInModal: {
    id: 'b9ba67f8-ac90-436b-91f9-24d9ca1cbd80',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleInMTOCommunity: {
    id: '4bd322d4-86a6-4391-b237-06f6ad34e27f',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleMultiColumn: {
    id: '412c7719-8f3d-478d-a215-5292c764c22d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AutoCloseConversationGlobalToggle: {
    id: '87bed0a6-c455-49a9-8b5b-db8eeb774ec0',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  AutoSuggestionCampaignHashtag: {
    id: 'acc4854f-ed9d-4082-8f56-5f2bba1d2bed',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendCellOverride: {
    id: '04405bd5-cbd9-4234-96a0-e715d6901d66',
    projectTeam: 'ClientForward',
    treatments: ['control', 'c1', 'c2', 'c3', 'c4', 'c5'],
    defaultTreatment: 'control',
  },
  LeadersSettingCard: {
    id: '60615d03-433d-468a-8753-c889e4777325',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphqlApiVnextEndpoint: {
    id: 'fd389c01-9fdd-440d-af71-41aab31f2a57',
    projectTeam: 'CrossPlatform',
    treatments: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    defaultTreatment: 2,
  },
  BackendGraphqlApiV5Endpoint: {
    id: '350d9e19-b73d-4c66-aef4-ff9729c625c4',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendLiveEventFeedCaching: {
    id: '298a9ad9-4a09-4bc9-b03c-57409c423b7e',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendLiveEventFeedCachingByTenant: {
    id: 'cf0d025e-c359-4988-8ab4-abed3a5f7e77',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendOcularCosmos: {
    id: '6efb151f-2e3b-466f-9fac-d14928e0d815',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BackendStreamieCosmos: {
    id: '13753d6c-0a9e-4927-bf80-524e4fb99bba',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BellPageSize: {
    id: '5d034307-8927-41cc-bdc1-2b9b000bc466',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },

  BespokeCommunityCreateEdit: {
    id: '63d38f2f-36df-4d03-b8ed-fa4f7e07b48f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  BookmarkThread: {
    id: '73b842f4-791f-4157-a5b2-76917957057f',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CampaignHoverCard: {
    id: '8302d48b-9695-4ebc-b5f6-ce2627cd0995',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsHub: {
    id: 'aefbd4b4-7240-4368-a057-35889afef9d3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsCoOrganizers: {
    id: 'c10ce8d9-b5ee-49cb-b815-544393f57c5e',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsExecutiveSponsorship: {
    id: '671d7ef6-08c8-4643-84c6-be6fe85d3df3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignFollowerDetails: {
    id: '0b6a86fb-6f38-45fc-b33c-c148670f7e92',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CKArticlePublisher: {
    id: '64f55486-31f3-4546-82fe-10ea3f98ad0e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CKArticlePublisherImageCropping: {
    id: '2873201c-5ca1-4d59-8031-ba6536123c88',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CKArticlePublisherImageResizing: {
    id: '1929a881-0079-4f07-8e2a-21b895810529',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CKArticlePublisherCaptions: {
    id: '3b435317-d875-425e-9624-1224408923fa',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CKRelayReplyPublisher: {
    id: '1688beca-32db-46d2-82d0-0e2e8d7e65cf',
    projectTeam: 'YammerClients',
    treatments: ['control', 'ckrelay', 'debug'],
    defaultTreatment: 'control',
  },
  CommunityAgent: {
    id: 'c41369ca-5536-441e-a32c-38d8947aca11',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityAgentAdmin: {
    id: '89a70f69-31bc-473e-bb20-bac2573aef81',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityAgentAtMention: {
    id: '76cb1d91-7e4b-4e4a-ab6d-9e6c73df52a7',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityAgentDogfood: {
    id: '5f291e60-f144-4b37-bbdb-f188da92b083',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityAgentPreview: {
    id: '80236f0f-01ca-4641-abc7-d32f80b3f944',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityAgentPrivatePreview: {
    id: 'a6ce3215-5c90-4743-b802-fed060ded4ed',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityAgentRecommendedReplies: {
    id: '1fb94136-db8f-4761-b4e7-0c34670f8614',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityAgentSPGrounding: {
    id: '89df79e9-b8e0-41cc-bfec-c48458ce388a',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityAIGeneratedBanner: {
    id: '1da6aa2e-1c02-4524-882a-e81a7260ab6d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityAIBannerUpdate: {
    id: '44201329-5134-4d8e-9a01-22c961704565',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityBadgeAdmin: {
    id: 'ace0c8c8-713f-433d-9807-2617506e7cbb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityCoachTips: {
    id: '45107b86-6a6f-4842-bd70-e3b9469361e6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityDynamicGroupMembership: {
    id: 'c92fddbc-5e38-4eba-8571-8237e9d34d14',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityFeatureConversation: {
    id: '40ad4c65-5ac7-4f59-bf4f-7b4fde1f1883',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityInsightsV2ThreadMetrics: {
    id: '1f6924f8-eebd-44f3-9bde-8d3e92b1dd95',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLeads: {
    id: '25f7fc54-ecbd-495e-9014-3bae205e8f91',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLeadsAndAutoPin: {
    id: 'beae692c-0343-4008-8003-64d56a4b8f19',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityRelayBanner: {
    id: 'db5c0e91-2fa0-47a7-81c5-81a451f2e0e9',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityRelayDataLoader: {
    id: '77c8c9d4-133c-4f72-a0e5-682f46dba497',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySettingsPage: {
    id: 'b050044d-86ef-45c6-985e-d8af5184405c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySetupTeachingBubbles: {
    id: '9665f8af-afb7-4f17-83d6-dcaa4e7ea275',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySidebarReorderStatic: {
    id: 'fa840604-fb43-466d-aa22-ead855fc7a46',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompactHeaderGeneral: {
    id: '3a8152dc-3f83-4334-ad84-be9acbbdb504',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompactHeaderStoryline: {
    id: 'affd7fb3-e3d6-4e99-968e-786e19ff8295',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignTargeting: {
    id: 'f86439d9-fddb-4af1-a506-a7984476c5c6',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignTargetingV2: {
    id: '4d59a1d3-1448-4c84-9816-7653768ab854',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompanyLogoInLCHeader: {
    id: 'ca32a32d-1b98-44ab-87fc-de35ef47838e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CondensedQuestionFeed: {
    id: '5bcf59f7-1b56-4445-8af4-6c373d676591',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CopilotAdoptionCommunityAdminFRE: {
    id: '3504b3ac-a57a-47d9-ae56-50689dd905ec',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CopilotCommunityConversion: {
    id: '121f2bb4-d221-457c-ad66-add8bef178eb',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CopilotFloatieButtonOverhaul: {
    id: '2e626d24-2992-4f75-887f-60fa89cae4ac',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ClientForwardExperimentForTesting1: {
    id: undefined,
    projectTeam: 'ClientForward',
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  ClientForwardExperimentForTesting2: {
    id: undefined,
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CrossPlatformExperimentForTesting1: {
    id: undefined,
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  CrossPlatformExperimentForTesting2: {
    id: undefined,
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DelegateRequest: {
    id: 'a95b95cb-8a11-449b-9add-7ef53c519768',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DelegateRequestBell: {
    id: '0708fb57-3c0b-4fa9-90e7-cea437075642',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DisableHomePremiumEventsCard: {
    id: 'cd4bead9-35db-4d51-8681-ccf8dd40f836',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DisablePollPostType: {
    id: '57738844-f4ad-4e10-bc25-8b1736ceae70',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DiscoverCommunitiesV2: {
    id: '39b449a2-1fd5-4599-89d0-e2a86a1a16a5',
    projectTeam: 'YammerClients',
    treatments: ['disabled', 'enabled'],
    defaultTreatment: 'disabled',
  },
  DiscoverOfficialCommunities: {
    id: 'b1de80d6-8d37-4ac3-980e-22264edb9654',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DivisionalBespokeCommunity: {
    id: '6f9c3ced-854b-4bc2-9af3-7db4be804007',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DogfoodPerfHUD: {
    id: 'f99f0b6b-0761-47b3-b436-28a004d68b30',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DomainMigration: {
    id: 'af478543-716d-4c0f-8233-eb60a9a38e20',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftAndScheduledPostSeeded: {
    id: '91348187-c1b4-4b20-bfa5-20c14284e3e0',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftPublisherWithCopilot: {
    id: 'f8124b33-1668-4c7b-937a-143c9b9d88d4',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ECDNSupportForEvents: {
    id: 'f94e0329-f9f9-4635-bea5-f5f91e0a5e63',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnableDeleteOptions: {
    id: 'd3c72095-a654-4ba6-bf11-380b9cd63c3d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EngageCustomBrandingTheming: {
    id: '25f08e9d-788e-4b31-8c4e-c35422a8e803',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EngageStorylinesCoverPhotoDragAndCrop: {
    id: '1af8f52c-abdf-4b83-91e6-e496b26fbb9b',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnhancedDigestDiscoveryDesign: {
    id: '281e84a8-537f-4440-93e2-9b7c91289a99',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'all_surfaces', 'list_view', 'reading_pane'],
    defaultTreatment: 'control',
  },
  EventPreviews: {
    id: 'ccd189e8-0d5a-41cc-b712-6700e43b913f',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ExperimentForTesting1: {
    id: 'fake-guid-for-testing',
    projectTeam: 'YammerClients',
    treatments: ['control', 't1'],
    defaultTreatment: 'control',
  },
  ExperimentForTesting2: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExpertNominationToggle: {
    id: '3c00bea5-5810-4dd2-b6cf-37c1e5de2b66',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ExpertSelfNominationInTeams: {
    id: '449d3c06-2f7d-4f67-b2f0-fc196dd0a305',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ExportEventQuestions: {
    id: '2fa88518-133f-4011-8b63-21d19542c02e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExtendedUnSeenCountEnabled: {
    id: '203aa725-6970-4a9e-aa58-0e1a9ddff681?',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FavoritesDragDropReorder: {
    id: '83593909-57d5-49e8-b3f4-eca2e2c142d2',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FeedLoadNumThreads: {
    id: 'ff83b0e2-9375-4aaa-9805-c9b8ac90c97b',
    projectTeam: 'YammerClients',
    treatments: [4, 3, 2, 1],
    defaultTreatment: 4,
  },
  FeedLoadMoreNumThreads: {
    id: '2a5e8839-400e-4152-80a4-c1c73fb07eeb',
    projectTeam: 'YammerClients',
    treatments: [4, 3, 2, 1],
    defaultTreatment: 4,
  },
  FilesCookielessAuth: {
    id: '63a5ce7d-ecb2-4090-a988-77b39994f4d7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  FlagThreadForLeader: {
    id: 'db475cc3-2f91-4c3a-8666-f4d6e5bd4855',
    projectTeam: 'CrossPlatform',
    treatments: ['false', 'true'],
    defaultTreatment: 'false',
  },
  FollowButtonHomeFeedThreadWithGreyColor: {
    id: '440bb634-1b43-44c8-9251-e9d02a469570',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  GroupFeedFilterAndSortByExp: {
    id: 'cff752e6-7035-4cd5-9264-d6340d64b3d9',
    projectTeam: 'YammerClients',
    treatments: ['all_recent_posts', 'default'],
    defaultTreatment: 'default',
  },
  GroupFeedSortRecentPostsWeb: {
    id: '0a7829b5-258c-4246-bdb3-710af4a15a53',
    projectTeam: 'ClientForward',
    treatments: ['enabled_with_extras', true, false],
    defaultTreatment: false,
  },
  GroupFeedSortRecentPostsTBE: {
    id: '03a6a30d-3bdf-4195-825c-7c56c3c07678',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HomeFeedGroupJoinButtonForRecommendations: {
    id: '37cab251-e8c5-40f4-b722-306d5a38e471',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HideFilesRelatedResources: {
    id: '50a6f470-346b-4b74-b21d-8f7fe1eb15c6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HideUserGlobalToggle: {
    id: 'ae3ffed3-2788-4126-a49b-5d07e70982a2',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityFilesTabVisibilitySetting: {
    id: 'be1a0c0e-29d3-4bac-99fb-73b8f3e837fd',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HomeFollowingFeed: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  IFrameSandboxForSharePointVideoCard: {
    id: '76d544b1-f002-49ff-82dd-b9aeb6344f0d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  InFeedUserSuggestions: {
    id: 'edc8645c-a10d-4ab1-aab3-34842a682c5d',
    projectTeam: 'ClientForward',
    treatments: ['control', 'rankie', 'enabled'],
    defaultTreatment: 'control',
  },
  GroupHoverCardV2: {
    id: 'e22b6ca1-ad23-4176-afbf-ab7b9365648e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  HydrantOptionsRefactoring: {
    id: '0e8fbf33-c82d-4332-8e40-d32f93d8c939',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ImageCompressionWeb: {
    id: 'fcb962de-8faa-4ac2-9240-8396d9bb96e3',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  InboxRelay: {
    id: 'a986997a-0f18-4e8b-a67a-53e57c7ac56d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  InformationBarriersPhase0: {
    id: 'f2e9d7b0-40ff-4d95-a80a-32ba65ab6a19',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: true,
  },
  InsightsFluent9Charts: {
    id: '710da333-e20b-4cb2-8a54-16e1fb474885',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  IntelligentImporterBulkDelete: {
    id: '7604b46b-048c-4797-ab0e-5f2b60961dbf',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  IntelligentImporterDeleteOnPublish: {
    id: 'fc579934-8971-4492-b9fc-6badebc9f093',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  KeywordOverrideAgentClientForward: {
    id: '18e9ec33-9279-445c-be4b-1563f46a22cf',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  KnowledgeBespokeCommunity: {
    id: '992716ec-e54a-48cd-9885-996aaacc3cd3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderAudienceFeed: {
    id: '45242ffb-565d-45c3-9aec-cead8078233c',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeaderAudiencePickerCustomGroups: {
    id: '6606e186-7edb-4abd-9dcb-f3457dae44f3',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeaderDashboard: {
    id: 'a359d84d-2676-4683-b255-48660a52ab10',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersViewDelegation: {
    id: '0598fa62-01bf-4ec2-9a26-1b049810999d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadershipCornerPinnedPosts: {
    id: 'ea5334fb-dfb9-4eb0-a15e-f2569df04eba',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderGroupsAddAsync: {
    id: 'c67be930-601d-40f2-a300-b3027ea21b10',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersAudienceM365Support: {
    id: 'bc62da45-9b8f-493a-940f-fc99ef2bddbb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersCascadeCTA: {
    id: '27cadbee-91e2-4dcd-b8f3-7e2a6b735c59',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },

  LeaderManagementActivityLog: {
    id: 'a4c3c54b-2bbf-4890-9129-1a45d59a3297',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LightboxFollowUsers: {
    id: 'd34c34e0-815c-4133-a17d-fe181895cf4d',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LimitConversationMoveSettingsAndFilter: {
    id: 'd9aa165e-da2d-4f08-a641-94bad06aa4e5',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LinkPreviewForSuggestedContent: {
    id: '2ec3f000-75fd-476b-94b2-20402ee020bd',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LiveEventsScaleLoadPerf: {
    id: '2a6b1ca4-5734-44b0-8d45-6b1c28976a51',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LoadFeedDataWhileRouting: {
    id: '9b715056-ccf7-49f7-8cc8-a02ad138ce80',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LoadThreadDataWhileRouting: {
    id: '18ee7168-7103-4b28-b005-3285d0cc356e',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LogProtobufEvents: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  LoopFilePreview: {
    id: '5245bb10-a64c-4813-a63b-b5efdce06728',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  RestrictPostingAnyGroupRollout: {
    id: 'de3b6c60-f521-4e7d-b89a-2c8d19d81785',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoption: {
    id: '344b3d2d-7100-41e9-a7b2-5a7c7d493a6f',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoptionSuggestedMembers: {
    id: '94573c25-cadd-485f-868f-d5e91d8ec8a4',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MicrosoftDesignerApp: {
    id: '49497680-16e2-43f4-bc69-0363063618c2',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MIPEnabledForEveryone: {
    id: '8d07b495-4c85-45ca-bdd9-eba55525e5de',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModulatorGroupSuggestionsEnabled: {
    id: 'bfd3fd32-6e3c-41c0-a792-8962dab5d283',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModerationAgent: {
    id: 'f4523130-d245-4c5e-ab36-80aade8123e5',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModerationAgentBlockPost: {
    id: '9759d18d-f0df-412d-a6d2-c096b52b4b9e',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModerationAgentBlockPostPreRollout: {
    id: '98385b36-4841-448b-81d3-741a878fd1fa',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModerationDetectedConversations: {
    id: '2f6e4e87-e664-4111-aba0-9d4ff6a69b20',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModerationThemeDetectedEmailNotification: {
    id: '2be957ef-2bdc-419a-aea6-f31d45a37731',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MoveConversationGlobalToggle: {
    id: '279a64ae-1e6c-463d-96da-1caf0e13ac7c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBlendedInbox: {
    id: '50746bf4-b609-43de-9287-c67c52b25d7d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOCampaigns: {
    id: 'ecb84501-2887-4ffe-8b66-bf00c1eca68d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOPolicyEngageAdminPortalPage: {
    id: '8d19e764-4203-47aa-945b-d3c1b656593f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOSpokeMemberAdmin: {
    id: '8f6b2261-de61-47b2-aa35-04dc58951dff',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnablePermalinkDeeplink: {
    id: '76203ecf-f92b-43ef-8a76-5aad974ac86b',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MultiTenantOrganization: {
    id: 'eaef51f5-5324-4fff-a9be-189da3de3a89',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MultiLanguagePublisher: {
    id: 'a73891cb-6522-4174-9099-3bf54074d633',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MutedAutoPlay: {
    id: '6df7dc9f-c8bd-42b5-8f6c-a66a266fe4c8',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MutedAutoPlayYouTubeVimeo: {
    id: '01c2bdc5-253b-44d1-babe-2f903582f8ff',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MyGroupsAdminOfFilter: {
    id: 'b1be92fd-10e9-404b-9ea0-9c987e54a8eb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  MyTeamAudience: {
    id: '1bffa728-eef3-43f2-8fe1-231e0eb95bcc',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  NetworkQuestionsInConversations: {
    id: 'b844c74d-8d80-41f4-968d-ca676ec73a76',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnboardingForCommunitiesInTeams: {
    id: 'f949716c-7ccd-4771-a8c2-8e8639df82e3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OneEventsAmaInsights: {
    id: '851fb6b9-7f1d-46e9-8682-b36dae5e8755',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayer: {
    id: '02c63db1-443a-42f4-97b6-f2346727994d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayerV2: {
    id: 'cd2b3546-0d46-4de1-8cac-bba88db3ac61',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayerNative: {
    id: 'c014fb1e-2d91-47e7-9d63-005fa8fd0490',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OdspFilePickerType: {
    id: 'a316df71-760f-47ec-97fd-84e11f14017c',
    projectTeam: 'YammerClients',
    treatments: ['control', 'group', 'onedrive'],
    defaultTreatment: 'control',
  },
  OfficeTopics: {
    id: '859373f9-fd86-46e8-a452-6ee50d68c6b6',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OpenPublisherWithModal: {
    id: '09f483a5-d75b-4ecc-840a-604411989c70',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OpenPublisherWithCopilotModal: {
    id: 'd3ce66e7-7c33-4f42-a167-9b275a20cd15',
    projectTeam: 'YammerClients',
    treatments: ['control', 'home', 'group_storyline_campaign', 'home_group_storyline_campaign'],
    defaultTreatment: 'control',
  },
  OrgDataQuality: {
    id: 'd1fc61f9-21ee-4e65-ad31-5882de876aae',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  OrgDataGovernance: {
    id: '411c2657-eb60-481d-bb6d-560bb841a565',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PeopleSuggestion3SV3: {
    id: '5d873e2e-b60c-43d5-801a-716cce0894bc',
    projectTeam: 'YammerClients',
    treatments: [false, 'enabled'],
    defaultTreatment: false,
  },
  PinnedFiles: {
    id: 'b2b7ae31-803f-42f8-833b-5d99489cc3a5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PostOnBehalfOfCommunityHomePublisher: {
    id: '2d1a61c7-1957-42ab-94b6-faa67b639669',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrefilledDefaultAudience: {
    id: 'a7c7ce2f-c586-40c7-abae-8d2c916a3572',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PremiumEventUpdates: {
    id: 'fb41ba99-36a2-432e-ae4a-0eb5c5fe9138',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivateRepliesAMA: {
    id: '88afd108-c163-46bc-b026-3cf910630eee',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherQuestionPrompt: {
    id: '10f80e06-acaa-4f62-a450-9816b690b2c7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherSuggestedTopics: {
    id: 'df2bddf4-61dd-4bc5-a1c7-778939fe36ae',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionsQueue: {
    id: '2c93f569-5660-4f0d-8f86-d308cba0cf9f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherV2: {
    id: 'fe1407c2-95b1-41f5-ace7-e2b62dfc660e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PWANotificationsDisabled: {
    id: '7eccfd46-c7ba-4002-879d-a959cda7a4aa',
    projectTeam: 'YammerClients',
    treatments: [true, false],
    defaultTreatment: false,
  },
  QuestionTitlesV3: {
    id: 'f1aeb59d-9236-4bb4-bb70-de6662f621eb',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuickNavManageMyThings: {
    id: '6a005258-30ee-443e-9b6e-ff1024e2b8c0',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PWALegacyBrokenExperience: {
    id: 'ede9763e-cfe8-4d4b-806f-21dd96be8409',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ReactionSimplification: {
    id: '7119895f-2b5b-4e09-93a4-a745c0c96c48',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ReadOnlyMode: {
    id: 'da33e692-30d5-4ade-b69f-f0b062b143e5',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RealtimeDebugEventReporting: {
    id: 'bf72c345-4045-4e0d-9d87-d0eb21ac5309',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RealtimeCometdDebugLogs: {
    id: '74ef23b7-615c-4816-a7a0-735517efed16',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RemoveTopicsSDKDependencyForVivaTopicsInFeeds: {
    id: '4992995f-b0d5-4b77-997c-703e977eda4d',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ReplaceUrlWithTitleInPublisher: {
    id: 'fa0e3cb3-5b7d-4569-a0ff-387664c3bc11',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ReportConversationMigration: {
    id: '3707513b-3ff6-4f15-80ee-61a53a476c88',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  RoleBasedFRE: {
    id: '6a88d980-c993-4549-8559-d07a184527a7',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },

  SearchDiscoverabilityFRE: {
    id: '179aa02b-969b-4288-b812-d2998c9b74e1',
    projectTeam: 'YammerClients',
    treatments: ['control', 'treatmenta', 'treatmentb'],
    defaultTreatment: 'control',
  },
  SearchAutocompletePromptSuggestions: {
    id: '5854e49a-0d2b-4fce-a819-9d7b5c3131be',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchAutocompleteTrendingThemeAndHistory: {
    id: '426e6aad-e967-409b-a2c2-acecb7bee41d',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SeededLeader: {
    id: 'bbbff046-d8f5-4177-ae8b-94360f942615',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ServerSharePointWebLinks: {
    id: 'cb6da583-69f6-422d-ba1c-0d1bf9af85e8',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SharePointVideoLinkPreviews: {
    id: '28323fd7-5caa-420d-998d-88f9224d9698',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointTempAuthUrlDeprecation: {
    id: 'e74e2593-fcd8-4b5c-999f-27f355a8aa17',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointTempAuthUrlDeprecationByTenant: {
    id: '1d004a2d-5c0e-4948-b13b-56a8aa69a3cf',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ShowUserCoverImage: {
    id: '1b55e8eb-36f3-4022-ac2c-2588d3869931',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SimplifyExpertVerification: {
    id: '6e3a017e-174f-42f3-91ef-de1fdf9d400b',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'inline_nudge', 'with_celebration', 'full_loop'],
    defaultTreatment: 'control',
  },
  SimplifyExpertVerificationInTeams: {
    id: 'cba448d9-3a20-4a10-98fd-8845ab4c6992',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SmallFileUpload: {
    id: '8c7e99ba-f485-46ea-9c15-963168beaf73',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SplitDataAndPresentationComponents: {
    id: '7bab3ae5-1adc-46f4-ba94-d301aa631953',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  Stories: {
    id: '06ca9171-c49a-4437-87ff-db71db80eca0',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesV2Cards: {
    id: '8ce624f9-6d36-46be-a1b8-66a4e9200e0c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAIGeneratedCoverPhotosEngageWeb: {
    id: 'bc559e59-be7c-4775-8073-85c04aa64fb2',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAIGeneratedCoverPhotosTBE: {
    id: '33ca4f2d-0f29-4976-b2c7-eeeb581caba4',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAnnouncementNotificationUrgency: {
    id: '4915afb3-27fd-4dac-8a02-dd6cc20310c7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAnnouncementTeachingBubbleAndDisableInfobar: {
    id: '8714e391-0b32-4202-9c11-5da24443b1c5',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },

  StorylineAsDefaultOnHomePublisher: {
    id: '607d8f62-67cc-46dd-8ab9-05dfe7093edf',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherLongv2: {
    id: 'cd8b5099-2742-4e28-bf15-e2170c394bd5',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDirectAndDigestRebrand: {
    id: 'a9c87cbf-fbab-45b9-b081-0d60f239ce37',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineEmptyFeedTeamsExperience: {
    id: '0df12f59-a0e3-4e69-98a0-607d0819470e',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineEmptyFeedEducationModule: {
    id: 'da942561-c451-42aa-a6c7-78147c88a638',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineFeaturedPostsSeeded: {
    id: '119a4e77-2cba-4202-b62b-616fb4fe1346',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineFeedFiltersTBE: {
    id: '847da636-3c33-4788-9ff5-b696f3e41217',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineMediaPost: {
    id: '289e4542-d271-4c2d-82bd-58aa4c43cbf0',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineMediaPostGA: {
    id: '25c564cd-65ef-485c-963f-9fd4bc62222b',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePOBOSeeded: {
    id: '12ad7bb8-cbab-47a8-8914-5ad27a89296d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherCoachingTips: {
    id: '31c06d83-f8eb-4423-a704-9294705c5ab5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsLongV3: {
    id: '6ccecbf9-797e-4289-b9ef-1976e6e78cd3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsShortV3: {
    id: 'aaaa837e-517c-491e-b691-512b2b14d6b3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineEventsSwimlaneView: {
    id: '5655c177-8b21-4480-90e5-2240a266a38c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadCoachingTips: {
    id: 'd02b84c7-32c3-42f4-8edc-a9116e7054cc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsLongV3: {
    id: '6980c260-9492-4754-a800-c0caf6bada91',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsShortV3: {
    id: '151b08a8-8224-4a4b-803a-d768bdfa2d72',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  StreamLiveEventDeprecationExtension: {
    id: '327f469b-604b-496a-9935-76ae9d9971e1',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SuggestedArticleFormatForSeeded: {
    id: 'a3c73919-324e-44fa-b779-773c8df18a2b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SuggestedContentGuidedAdminExperience: {
    id: 'c6de6087-db20-49c6-bf26-75f90a2712da',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  SystemInitiatedEngageFeedback: {
    id: 'ffa292ef-515c-4659-ad4a-ec27203372de',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TBEConnectionsSuggestion: {
    id: 'ad3f13e3-4ee9-48be-abf3-baf804505b92',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TBEMultiLanguagePublisher: {
    id: 'fc467fb9-c6de-4dbe-a436-18828bd75068',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TBENewFollowersPage: {
    id: '43b9e3fb-2637-4ab1-a1e9-0a04cc61cd2d',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBackButton: {
    id: '78187586-38f7-4984-b4e4-b8b9ea9a06d5',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsClientDataLayer: {
    id: '97d45c1b-5a03-4a88-8462-828883433b80',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesCommunityCDLSync: {
    id: 'd6a15d4d-8118-47cf-98b1-4558066fd8cd',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesBackgroundLoadR4Rollout: {
    id: '619f23e5-7de9-4687-afd3-94eeb0eb8214',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesCachedFeedLoad: {
    id: '8584525d-f735-4ca0-b683-a107d7a88e5c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesTimeoutBasedCachedFeedLoad: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesCommunityFeatures: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesCommunityFeedRelay: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesIdbCache: {
    id: '50974028-d286-4fdc-9aba-91e806e37f85',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesLastReadBar: {
    id: 'c2c26c2f-8454-45a9-96b1-3961765ad7c7',
    projectTeam: 'YammerClients',
    treatments: [false, true, 'diagnostics_last_read_bar'],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesEvents: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: ['off', 'on', 'teams_storyline_only'],
    defaultTreatment: 'off',
  },
  TeamsBrandedExperiencesOpenStorylineTab: {
    id: '8c6b93a1-15bf-466c-83e1-29f6f39e92b3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesPinnedCollapsibleRightRail: {
    id: '966cdc2d-6fc6-4b0d-830f-23c56ae2b37b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesServiceWorker: {
    id: '305440a3-91cc-4ad2-aba1-f78cf9c6d5d1',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesUseEngageCoachmarks: {
    id: '00b52e87-edbe-421e-a199-95a3aa4304d8',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesFREShowLearnMore: {
    id: '8838667e-0f4d-45aa-92cb-7a58c69b51ae',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesFilesTab: {
    id: '13c02fd2-c546-4d75-9020-31fc16fabd40',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedRightRailRedesign: {
    id: 'd01019ad-3863-4fd4-bc34-0ec7b374f204',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsFocusCommandsInEngageApp: {
    id: '0a2c91a5-5b31-412b-9c97-05f839816a93',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingAccess: {
    id: 'a1e4ad9b-3252-476f-8d36-d1ab593eea1e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingDisableReactionsOption: {
    id: 'd3c388f4-9b2a-4dc5-859f-e445aaf19428',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingMaskIdentitiesBanner: {
    id: '4e3e9c95-61f3-4696-9261-2f133c295417',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAFeedReset: {
    id: '843e64a0-d562-462b-bc22-14404b918cad',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAInOneEventsLandingPage: {
    id: '485d9fda-701c-4185-8207-fd52c4a3c351',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnaLocalDevelopment: {
    id: undefined,
    projectTeam: 'YammerClients',
    treatments: ['off', 'on'],
    defaultTreatment: 'off',
  },
  TeamsQnAPostAsModeratorNotifications: {
    id: 'f28bf19d-cee1-497a-9796-d3251d619ba8',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAPostAsModeratorSenderDetails: {
    id: '24204a26-d022-4e4e-a732-4be74b1e5a67',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnARoutingHeadersForSplitRegion: {
    id: 'f417cc13-0ecc-4b69-9d24-dbfe7ad407b3',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnANestedAuthAppSupport: {
    id: 'feb5e4bb-2d8f-4d84-9009-5c0b8101c495',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAUXUpdates: {
    id: 'd5fb4cfa-f8df-4ff6-9e44-d00b38ce728c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsTownhallEventInVivaEngage: {
    id: 'ae8b760b-8ed5-4477-b1b0-30715384c65f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsUserInitiatedEngageFeedback: {
    id: 'b0f39467-d849-4e66-b919-0227eb9cfe58',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ThreadCopyLinkV2: {
    id: 'a7d57c9e-704f-488d-8ab9-a0dfad8c42dd',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ToggleEventModeration: {
    id: '11bb4714-06bb-4ab7-a581-4d212b079d0e',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TownhallEmbedRingOverride: {
    id: '31f3462e-6d97-48e5-b275-1ee2940f506b',
    projectTeam: 'YammerClients',
    treatments: ['control', 'ring2', 'ring3', 'ring3_6', 'ring3_9', 'general'],
    defaultTreatment: 'control',
  },
  TownhallMeetingOptions: {
    id: '9b90e936-843b-40a5-9af4-c21f498068f2',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  UCBSquareDesign: {
    id: 'd5db8c8b-cd61-4e4f-ad3c-7129969f7c78',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  UseBatchedFiles: {
    id: 'f39078e3-d850-4dac-b19b-bcf38ea44ef3',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  UseEditV1Api: {
    id: '51ffdb63-5676-4db2-906f-8eb14ed1fba3',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserInitiatedEngageFeedback: {
    id: '4a4e5a8a-136b-48f9-a62c-d9712b84bf64',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UserSettingsNotificationsLoader: {
    id: 'bfbf31a4-b608-4f2b-836f-84dffb94441c',
    projectTeam: 'CrossPlatform',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageAdminBanner: {
    id: 'f81f90cd-46c2-4caa-990b-f91f448ca776',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  EventAnonymousPosting: {
    id: '1e991dfc-1c61-4ef3-bd31-9bdfb2405444',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivatePremiumEventCreation: {
    id: 'e07f8662-6047-497a-a4b4-cefc52a7b911',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  PremiumEventExperience: {
    id: 'f0e76685-84e0-4669-b373-83c694f6e96b',
    projectTeam: 'CrossPlatform',
    treatments: ['none', 'all'],
    defaultTreatment: 'none',
  },
  PremiumEventCalendarOnBehalfOfExperience: {
    id: '0b3f8115-c90f-4010-a064-7b2fc459b3c5',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCoverImage: {
    id: '52589660-bd2e-495b-8264-3729d18bbbb5',
    projectTeam: 'YammerClients',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageDeepLinkFromOWA: {
    id: '2809a765-1843-4189-9460-cb296610a0f7',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageGlobalCopilot: {
    id: '19bfe564-82b3-45f6-bd80-ef4f63d5aa6e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageGlobalCopilotTenant: {
    id: '06da6748-d9ba-414c-9f93-bbb958bddb72',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAugLoopEnvironment: {
    id: 'f11bbd96-d6c3-46ab-866c-1662d9bfed90',
    projectTeam: 'YammerClients',
    treatments: ['int', 'dogfood', 'prod', 'test', 'msit'],
    defaultTreatment: 'prod',
  },
  VivaEngagePremium: {
    id: '7967125b-c339-443b-927f-c7f0a908ae30',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCollapsiblePanelRecommendations: {
    id: '2cc0b58b-35a0-47d8-aee4-51c37f7aef0b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotBE: {
    id: '8d51b16b-0cf0-414e-b3d9-5ca3bb56b443',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageCopilotDebug: {
    id: '1eeb6174-f2b4-41eb-b818-77f45b91042f',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotWAGpt4: {
    id: '0453b07b-59e0-4345-8514-d19e436d946f',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageCopilotWAPersonalized: {
    id: '44420984-e67f-4c5b-a5c6-7b43faaef021',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageLC: {
    id: 'f01b8142-2f47-492c-a640-b3836b8b7afc',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipChronoFeed: {
    id: '0bc20bf9-4197-40fe-b262-912c9bebf58b',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipCuratedFeed: {
    id: '3f8817dc-c4c0-464c-a2f2-34b5d1b0fd81',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCampaignPlugin: {
    id: 'de15fe0d-5855-425d-9a34-0400ef1aece4',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageTeamsLiveEventMobile: {
    id: '6f2f97ba-ec37-4508-8b12-fbbf3e648186',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NoWFMessageBodyInGroupMessageCreationResponse: {
    id: '9c4d957c-94b1-43d8-bcc6-84a14db0cde2',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MinimalWFPayloadOnReplyPosting: {
    id: '4def6d5d-ad49-4be4-8d63-dede011d672f',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MessagesReactionsAPI: {
    id: '32f18ade-ec9f-478d-aa5a-fa2baa4e282d',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: 'false',
  },
  MessagesReactionsAPIV2: {
    id: '599e96dc-6975-4845-bc10-b13416160cd8',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: 'false',
  },
  MessagesReactionsAPIWrite: {
    id: 'cb180888-5f33-4086-a8d5-099fc5626caf',
    projectTeam: 'ClientForward',
    treatments: [false, true],
    defaultTreatment: 'false',
  },
  OptimizedReactionsFetching: {
    id: '5fc95130-6444-4e47-92fc-f3ca5a16ac6f',
    projectTeam: 'ClientForward',
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UnseenThreadStarterInInbox: {
    id: '6efec7a9-947a-4e04-a697-4d71dbd7c7af',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleSuggestionBar: {
    id: '5b03cdde-e928-4b07-9d1c-e99354559a4e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleTableofContents: {
    id: '158f5bd7-a8ca-4657-b9e7-93ff6c38d56c',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsDigest: {
    id: '514fb1e2-4cf2-4fa7-a11d-4ac77bd171e0',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NotificationsAnnouncementCopyUpdate: {
    id: '3f8a2ab1-c8ae-48b7-8258-10334740950e',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  NotificationTracker: {
    id: 'c9cac102-44db-442a-817c-ada36818fc31',
    projectTeam: 'YammerClients',
    treatments: [false, true],
    defaultTreatment: false,
  },
  ViewerTimeZoneCapture: {
    id: '90a3f9de-3505-4c81-8f27-f1e60888a316',
    projectTeam: 'CrossPlatform',
    treatments: [false, true],
    defaultTreatment: false,
  },
};

export type ExperimentConfigs = Record<Experiment, ExperimentConfig>;

export type ExperimentTreatments = Record<Experiment, ExperimentTreatmentValue>;

export const defaultExperimentTreatments: ExperimentTreatments = (
  Object.keys(experimentConfigs) as Experiment[]
).reduce(
  (acc: ExperimentTreatments, key: Experiment) => ({
    ...acc,
    [key]: experimentConfigs[key].defaultTreatment,
  }),
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  {} as ExperimentTreatments
);

export interface EcsExperiments {
  readonly treatments: ExperimentTreatments;
  readonly treatmentsFromService: Partial<ExperimentTreatments>;
  readonly treatmentOverrides: Partial<ExperimentTreatments>;
}
